import Vue from 'vue';
export default Vue.extend({
    name: 'sizeable',
    props: {
        large: Boolean,
        medium: Boolean,
        size: {
            type: [Number, String]
        },
        small: Boolean,
        xLarge: Boolean
    }
});
//# sourceMappingURL=sizeable.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/vuetify/lib/mixins/sizeable.js
// module id = null
// module chunks = 